import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from './click-outside/clickOutside.directive';
import { ShadowCssDirective } from './shadow-css/shadow-css.directive';
import { DebounceClickDirective } from './debounce-click/debounceClick.directive';
import { DebounceTapDirective } from './debounce-tap/debounceTap.directive';
import { TransitionGroupItemDirective } from './reordeer-animation/transition-group-item.directive';
import { TransitionGroupComponent } from './reordeer-animation/transition-group.component';
import { ThrottleClickDirective } from './throttle-click/throttle-click.directive';
import { LimitToDirective } from './limit-to/limitTo.directive';
import { SopoTooltipDirective } from './sopoTooltip/sopo-tooltip.directive';

@NgModule({
    declarations: [
        ClickOutsideDirective,
        ShadowCssDirective,
        DebounceClickDirective,
        DebounceTapDirective,
        TransitionGroupComponent,
        TransitionGroupItemDirective,
        ThrottleClickDirective,
        LimitToDirective,

    ],
    imports: [
        CommonModule,
        SopoTooltipDirective,
    ],
    exports: [
        ClickOutsideDirective,
        ShadowCssDirective,
        DebounceClickDirective,
        DebounceTapDirective,
        TransitionGroupComponent,
        TransitionGroupItemDirective,
        ThrottleClickDirective,
        LimitToDirective,
        SopoTooltipDirective
    ],
})
export class SharedDirectivesModule {}
